import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";
import SectionTitleTwo from "../components/SectionTitles/SectionTitleTwo";
import UnderConstruction_zn from "../container/Blank/UnderConstruction_zn";

// import EmptyOne from '../container/Empty/EmptyOne';

const ReceptionBanquet = () => {
  const show = false;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="接待 &amp; 宴会 | ICSI 2022" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="接待 &amp; 宴会"
          content="中文参会通道"
          contentTwo="接待 &amp; 宴会"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <div
              className="col-xl-6 col-lg-6 col-12"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="about-content-area">
                <SectionTitleTwo
                  // subTitle="Every day brings new challenges"
                  title="Beer Festival Reception, Lunch and Banquet are all included in the registration fees."
                />

                <h5>Beer Festival Reception</h5>
                <p>Date: July 17, 2021 </p>
                <p>Place: Dong Hai Hall (东海厅)</p>
                <h5>Buffet Lunch</h5>
                <p>Date: July 18 &amp; 19, 2021 </p>
                <p>Place: Aegean Sea cafeteria (爱情海自助餐厅)</p>
                <h5>Banquet</h5>
                <p>Date: July 18, 2021 </p>
                <p>Place: Dong Hai Hall (东海厅)</p>

                {/* <Link className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" to={process.env.PUBLIC_URL + "/about"}>Learn More</Link> */}
              </div>
            </div>
            <div className="about-content-area">
              <img
                src="http://www.lanhai.cn/LHJD/outImages/hotel/20170223135426890_467185.jpg"
                width={400}
              />
              <img
                src="http://39.98.207.139:8080/icsi2021/wp-content/uploads/rb/beer-1.jpg"
                width={400}
              />
              <img
                src="http://39.98.207.139:8080/icsi2021/wp-content/uploads/rb/seafood-2.gif"
                width={400}
              />
              <img
                src="http://39.98.207.139:8080/icsi2021/wp-content/uploads/rb/seafood-3.gif"
                width={400}
              />
            </div>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
          <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <SEO title="接待 &amp; 宴会 | ICSI 2022" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="接待 &amp; 宴会"
          content="中文参会通道"
          contentTwo="接待 &amp; 宴会"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <UnderConstruction_zn/>
        </EmptyTwo>
        {/* <AboutFive />
          <TestimonialContainer classOption="bg-primary-blue" />
        <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default ReceptionBanquet;
